/**
 * Maintained by Sandon.
 */
export function arrayContentSame (arr1, arr2) {
  const set1 = new Set(arr1)
  const set2 = new Set(arr2)
  if (set1.size !==  set2.size)  return false

  for (let item of set2) {
    if (!set1.has(item)) return false
  }

  return true
}
export function genMap (list, idPropName = 'id') {
  const map = {}
  list.forEach(node => {
    map[node[idPropName]] = node
  })
  return map
}
